export default __webpack_public_path__ + "locales/vi/ChangeUserStatusDialog.json?hash=bc3e1ceef0e11dfd8947f959bb49ec7b";